<app-breadcrumb [master]="'Wyniki konkursów'" [parentName]="'Lista importów'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">

    <mat-form-field class="list-filter">
      <mat-label>Nazwa pliku</mat-label>
      <input matInput placeholder="Nazwa pliku" name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Nazwa konkursu</mat-label>
      <input matInput placeholder="Nazwa konkursu" name="contains$competitionName" [(ngModel)]="initialFilters.contains$competitionName">
    </mat-form-field>

    <app-datepicker
      class="list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict-users
      label="Użytkownik"
      class="list-filter"
      [(ngModel)]="initialFilters.createdBy" name="createdBy"
    ></app-dict-users>

    <app-dict
      [multiple]="false" label="Status"
      class="list-filter"
      dictType="import_status"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>
  </form>

  <div class="list-buttons"  fxLayout="row" fxLayoutAlign="end" >
    <div>
<!--      <button *ngIf="(userPermissions | async).registration.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report"-->
<!--              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>


  <table mat-table [dataSource]="imports" >

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa pliku </th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <ng-container matColumnDef="importDate">
      <th mat-header-cell *matHeaderCellDef> Data importu </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy?.uuid]">{{element.createdBy?.username}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="importRow">
      <th mat-header-cell *matHeaderCellDef> Liczba rekordów zaimportowanych </th>
      <td mat-cell *matCellDef="let element">
        {{element.importedRows}}
      </td>
    </ng-container>

    <ng-container matColumnDef="competitionName">
      <th mat-header-cell *matHeaderCellDef> Nazwa konkursu </th>
      <td mat-cell *matCellDef="let element"> {{element.competitionName}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
          <ng-container *ngIf="element.status.key === IMPORT_STATUS_IN_PROGRESS">
            ({{element.progress}}%)
          </ng-container>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div fxLayout="column" >
          <button  fxFlex="100"  mat-icon-button [matMenuTriggerFor]="menu"  *ngIf="(userPermissions | async).marketing.read_report" ><mat-icon>expand_more</mat-icon></button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button *ngIf="(userPermissions | async).marketing.read_report" [disabled]="!(userPermissions | async).marketing?.read_report"  mat-menu-item (click)="downloadImportFile(element)">Pobierz plik importu</button>
            <button *ngIf="(userPermissions | async).marketing.delete"  [disabled]="!(userPermissions | async).marketing?.delete" mat-menu-item (click)="deleteImport(element)">Usuń</button>
            <button *ngIf="(userPermissions | async).marketing.read_report && element.status?.key === IMPORT_STATUS_IN_CONFIGURATION" [disabled]="!(userPermissions | async).marketing?.read_report" mat-menu-item (click)="backToConfiguration(element)">Wróć do konfiguracji</button>
          </mat-menu>
        </div>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
